import AllDropdownItem from "../../../table-actions-panel/models/selection-dropdown-item/AllDropdownItem/AllDropdownItem";

export default class AllContactsSelectionItem extends AllDropdownItem {
    getSelectedTranslation() {
        return {
            key: "si.table-actions-panel.options.contacts.all.selected",
            replacements: {
                numberOfItems: this.formatValue(),
            },
        };
    }
}
